import * as types from './actionType'
import { hasFields } from '../../util/Filter'

export const initialState = {
  columnData: [
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: 'Project Name',
      align: 'center',
    },
    {
      id: 'createdBy',
      numeric: false,
      disablePadding: false,
      label: 'Project Creator',
      align: 'center',
    },
    {
      id: 'createDate',
      numeric: false,
      disablePadding: false,
      label: 'Created Date',
      align: 'center',
      type: 'date',
    },
    {
      id: 'channel',
      numeric: false,
      disablePadding: false,
      label: 'Channel',
      align: 'center',
    },
    {
      id: 'locationName',
      numeric: false,
      disablePadding: false,
      label: 'Photoshoot Location',
      align: 'center',
    },
    {
      id: 'shootStartDate',
      numeric: false,
      disablePadding: false,
      label: 'Start Date',
      align: 'center',
      type: 'date',
    },
    {
      id: 'shootEndDate',
      numeric: false,
      disablePadding: false,
      label: 'End Date',
      align: 'center',
      type: 'date',
    },
    {
      id: 'sampleCount',
      numeric: false,
      disablePadding: false,
      label: 'Samples',
      align: 'center',
    },
  ],
  order: 'asc',
  orderBy: 'id',
  page: 0,
  projectLocation: [],
  rowsPerPage: 25,
  createProjectRequest: {
    name: '',
    type: '',
    marketingPid: '',
    notes: '',
    shootStartDate: null,
    shootEndDate: null,
  },
  projectTypes: ['', 'ISM', 'TCIN', 'CGI', 'COLLECTION'],
  projects: [],
  projectMetricsById: {},
  sampleProjectData: new Map(),
  filteredProjects: [],
  filterText: '',
  getProjectsPending: false,
  getProjectsMetricsPending: false,
  getProjectSamplesFailure: false,
  getProjectSamplesPending: false,
  createProjectPending: false,
  createProjectPopupVisible: false,
  getBuildingsPending: false,
  getBuildingsFailure: false,
  tabValue: '',
  sampleCount: [],
  filterValue: '',
  requestSamplesStatus: '',
  flyoutOpen: false,
  editSuccess: false,
  projectsTotalCount: 0,
  projectsPagesCount: 0,
  projectStatusById: {},
  projectStatusPending: false,
  projectStatusFailure: false,
  tcinStatusById: {},
  tcinStatusPending: false,
  tcinStatusFailure: false,
}

export default function projects(state = initialState, action) {
  switch (action.type) {
    case types.PROJECTS_SHOW_CREATE_POPUP: {
      return Object.assign({}, state, {
        createProjectPopupVisible: true,
      })
    }
    case types.PROJECTS_CLOSE_CREATE_POPUP: {
      return Object.assign({}, state, {
        createProjectPopupVisible: false,
        createProjectRequest: {
          name: '',
          type: '',
          marketingPid: '',
          notes: '',
          shootStartDate: null,
          shootEndDate: null,
        },
      })
    }
    case types.PROJECTS_REQUEST_PENDING: {
      return Object.assign({}, state, {
        getProjectsPending: action.payload.pending,
      })
    }
    case types.PROJECTS_METRICS_REQUEST_PENDING: {
      return Object.assign({}, state, {
        getProjectsMetricsPending: action.payload.pending,
      })
    }
    case types.PROJECTS_REQUEST_SUCCESS: {
      const {
        projects: incoming = [],
        append = false,
        totalCount = 0,
        pagesCount = 0,
      } = action.payload || {}
      if (!append) {
        return Object.assign({}, state, {
          projects: incoming,
          filteredProjects: incoming,
          projectsTotalCount: totalCount,
          projectsPagesCount: pagesCount,
        })
      }
      const existing = Array.isArray(state.projects) ? state.projects : []
      const nextProjects = [...existing]
      const indexById = new Map()
      existing.forEach((project, index) => {
        if (project?.id != null) indexById.set(project.id, index)
      })
      incoming.forEach((project) => {
        if (!project || project.id == null) return
        const existingIndex = indexById.get(project.id)
        if (existingIndex != null) {
          nextProjects[existingIndex] = project
        } else {
          nextProjects.push(project)
        }
      })
      return Object.assign({}, state, {
        projects: nextProjects,
        filteredProjects: nextProjects,
        projectsTotalCount: totalCount || state.projectsTotalCount,
        projectsPagesCount: pagesCount || state.projectsPagesCount,
      })
    }
    case types.CURRENT_PROJECT_REQUEST_SUCCESS: {
      const { projects: existingProjects = [] } = state
      const {
        payload: { projects: currentProject = {} },
      } = action
      const { id: currentProjectID = '' } = currentProject
      const listWOCurrentProject = existingProjects.filter(
        (obj) => obj.id !== currentProjectID
      )
      return Object.assign({}, state, {
        projects: [currentProject, ...listWOCurrentProject],
        filteredProjects: [currentProject, ...listWOCurrentProject],
      })
    }
    case types.BUILDINGS_REQUEST_SUCCESS: {
      return Object.assign({}, state, {
        ...state,
        projectLocation: action.payload.data.data.buildings,
      })
    }

    case types.BUILDINGS_REQUEST_PENDING:
      return Object.assign({}, state, {
        getBuildingsPending: action.payload.pending,
      })

    case types.BUILDINGS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        getBuildingsFailure: true,
      })
    case types.PROJECTS_SET_FILTER: {
      return Object.assign({}, state, {
        filterText: action.payload.filter,
        filteredProjects: state.projects.filter((i) =>
          hasFields(i, action.payload.filter)
        ),
      })
    }
    case types.PROJECTS_CLEAR_FILTER: {
      return Object.assign({}, state, {
        filterText: '',
        filteredProjects: state.projects,
      })
    }
    case types.PROJECTS_SET_METRICS_DATA: {
      const { projectId, data } = action.payload || {}
      if (!projectId) return state
      return Object.assign({}, state, {
        projectMetricsById: Object.assign({}, state.projectMetricsById, {
          [projectId]: data,
        }),
      })
    }
    case types.PROJECTS_UPDATE_CREATE_FIELD: {
      return Object.assign({}, state, {
        createProjectRequest: Object.assign({}, state.createProjectRequest, {
          [action.payload.field]: action.payload.value,
        }),
      })
    }
    case types.PROJECT_GET_SAMPLES_SUCCESS: {
      let newSampleProjectData = new Map(state.sampleProjectData)
      newSampleProjectData.set(
        action.payload.projectId.toString(),
        action.payload.data
      )
      return Object.assign({}, state, {
        getProjectSamplesFailure: false,
        sampleProjectData: newSampleProjectData,
      })
    }
    case types.PROJECT_GET_SAMPLES_FAILURE: {
      return Object.assign({}, state, {
        getProjectSamplesFailure: true,
      })
    }
    case types.PROJECT_GET_SAMPLES_PENDING: {
      return Object.assign({}, state, {
        getProjectSamplesPending: action.payload.pending,
      })
    }
    case types.SET_TABVALUE: {
      return Object.assign({}, state, {
        tabValue: action.payload.tabValue,
      })
    }
    case types.SET_SAMPLE_PROJECTS_VALUE: {
      return Object.assign({}, state, {
        ...state,
        sampleCount: action.payload.sampleCount,
      })
    }
    case types.SET_PROJECTS_SEARCH_VALUE: {
      const {
        payload: { filterValue = '' },
      } = action
      return Object.assign({}, state, {
        ...state,
        filterValue,
      })
    }
    case types.SET_REQUEST_SAMPLES_STATUS: {
      return Object.assign({}, state, {
        ...state,
        requestSamplesStatus: action.payload.requestSamplesStatus,
      })
    }
    case types.EDIT_FLYOUT_OPEN: {
      return Object.assign({}, state, {
        ...state,
        flyoutOpen: !state.flyoutOpen,
      })
    }
    case types.EDIT_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        ...state,
        editSuccess: action.payload,
      })
    }
    case types.FETCH_PROJECT_STATUS_PENDING: {
      return Object.assign({}, state, {
        projectStatusPending: action.payload.pending,
      })
    }
    case types.FETCH_PROJECT_STATUS_SUCCESS: {
      const { projectId, data } = action.payload || {}
      return Object.assign({}, state, {
        projectStatusFailure: false,
        projectStatusById: Object.assign({}, state.projectStatusById, {
          [projectId]: data,
        }),
      })
    }
    case types.FETCH_PROJECT_STATUS_FAILURE: {
      return Object.assign({}, state, {
        projectStatusFailure: true,
      })
    }
    case types.FETCH_TCIN_STATUS_PENDING: {
      return Object.assign({}, state, {
        tcinStatusPending: action.payload.pending,
      })
    }
    case types.FETCH_TCIN_STATUS_SUCCESS: {
      const { projectId, data } = action.payload || {}
      return Object.assign({}, state, {
        tcinStatusFailure: false,
        tcinStatusById: Object.assign({}, state.tcinStatusById, {
          [projectId]: data,
        }),
      })
    }
    case types.FETCH_TCIN_STATUS_FAILURE: {
      return Object.assign({}, state, {
        tcinStatusFailure: true,
      })
    }
    default:
      return state
  }
}
